module.exports = __webpack_public_path__ + "static/media/tensorflow.76db955f.svg";